import React from 'react';
import { CalendarIcon, ClockIcon } from 'lucide-react';
export function EventDetails() {
  return <section id="kdaj" className="py-20 px-6 scroll-mt-24 relative bg-olive/[0.06]" data-id="element-13">
      <div className="max-w-xl mx-auto" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-16">Kdaj?</h2>
          <div className="w-16 h-px bg-gold/50 mx-auto" data-id="element-17"></div>
        </div>

        <div className="flex flex-col items-center text-center space-y-6 p-8 bg-white/40 rounded-sm border border-olive/5 shadow-sm" data-id="element-18">
          <div className="w-12 h-12 rounded-full bg-ivory flex items-center justify-center text-gold shadow-sm" data-id="element-19">
            <CalendarIcon size={24} strokeWidth={1.5} data-id="element-20" />
          </div>
          <div data-id="element-21">
            <h3 className="text-2xl mb-4" data-id="element-22">Nedelja, 5. 7. 2026</h3>
            <div className="space-y-3 font-sans text-soft-brown/90 text-lg" data-id="element-23">
              <div className="flex items-center justify-center gap-2" data-id="element-24">
                <ClockIcon size={18} className="text-olive/60" data-id="element-25" />
                <span data-id="element-26">Ob 11.00 – sv. maša</span>
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-27">
                <ClockIcon size={18} className="text-olive/60" data-id="element-28" />
                <span data-id="element-29">Od 13.00 dalje – piknik in druženje</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}